/**
 * 请求
 * @author Clive
 */
import axios from 'axios'
import { clearLoginInfo } from './index'

// 请求超时时间, 单位:毫秒
const requestTimeout = 360000

// create an axios instance
const service = axios.create({
  baseURL: '/bear-scale', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: requestTimeout // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    config.headers['Teacher-Token'] = getTeacherToken()
    if (config.requestForm) {
      if (config.data)
        config.data = json2Form(config.data)
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 0) {
      alertMsg(res.msg || 'error')

      console.log('resp:' + JSON.stringify(res))

      // 401: Illegal token | Other clients logged in | Token expired;
      if (res.status === 401) {
        // location.href = '/#/wx-auth'
        clearLoginInfo()
      }
      return Promise.reject(res.msg || 'error')
    } else {
      return res
    }
  },
  error => {
    console.log('[error]: ' + error) // for debug
    let msg = error.message
    if (msg === 'Network Error') {
      msg = '网络错误或服务器忙碌'
    }
    if (msg === 'timeout of 10000ms exceeded') {
      msg = '请求超时,请稍候再试'
    }
    alertMsg(msg)
    return Promise.reject(error)
  }
)

export default service

function getTeacherToken() {
  const teacherInfo = localStorage.getItem('teacherInfo')
  // alert(teacherInfo)
  return teacherInfo ? JSON.parse(teacherInfo).token : ''
}

function alertMsg(msg) {
  alert(msg)
}

function json2Form(json) {
  const formData = new FormData();
  Object.keys(json).forEach((key) => {
    formData.append(key, json[key]);
  })
  return formData;
}



// WEBPACK FOOTER //
// ./src/utils/request.js